import React from "react";

export default function Cover({ data, error }) {
  return (
    <section id="cover">
      <div className="cover">
        <div className="profile">{error ? "NO" : data.name[0]}</div>
      </div>
    </section>
  );
}
